module.exports = __webpack_public_path__ + "img/applepay1.08c7e467.png";